import SsoLoginPage from '@/pages/sso/SsoLoginPage.vue'

export default [
  {
    path: '/sso/login',
    name: 'sso-login',
    component: SsoLoginPage,
    meta: {
      title: 'Єдиний вхід BEST LEASING',
      sso: true,
    },
  },
]
